import React from "react";
import ProductCard from "../ProductCard";
import { Reveal, useReveal } from "./_shared";

export default function KurtaTrio({ kurtas }) {
  const ref = useReveal(0.1);
  return (
    <section
      className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32"
      data-testid="featured-kurtas-section"
    >
      <Reveal className="max-w-2xl mb-14">
        <p className="eyebrow">The Short Kurta Trio</p>
        <h2 className="font-serif-display text-4xl md:text-5xl mt-3">
          Three kurtas. One for every occasion that matters.
        </h2>
      </Reveal>
      <div ref={ref} className="grid md:grid-cols-3 gap-6 md:gap-10 reveal-stagger">
        {kurtas.map((p, i) => (
          <ProductCard key={p.id} product={p} index={i} />
        ))}
      </div>
    </section>
  );
}
